export const splitPascalCase = ( string ) => {
    let name = string.replace(/([A-Z])/g, ' $1');
    name = name.replace(/^./, function(str){ return str.toUpperCase(); });
    return (
        name
    )
}